var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnkh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280 280H179.266C222.055 235.396 263.469 169.963 263.469 116.688C263.469 44.719 223.812 0 160 0S56.531 44.719 56.531 116.688C56.531 169.963 97.945 235.396 140.734 280H40C35.594 280 32 283.578 32 288S35.594 296 40 296H152V504C152 508.422 155.594 512 160 512S168 508.422 168 504V296H280C284.406 296 288 292.422 288 288S284.406 280 280 280ZM160 16C214.781 16 247.469 53.641 247.469 116.688C247.469 171.844 197.062 240.469 160 276.922C122.938 240.469 72.531 171.844 72.531 116.688C72.531 53.641 105.219 16 160 16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnkh);
export default __webpack_public_path__ + "static/media/ankh.7f5b45cf2576736a1568e0adb1a66109.svg";
export { ForwardRef as ReactComponent };